import { style } from '@angular/animations';
import { Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[negativeValue]',
    standalone: false
})
export class NegativeValueDirective implements OnInit, OnChanges {
  @Input('numberValue') value: number;

  constructor(private el: ElementRef) { }

  ngOnInit() {
    this.checkNumber();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.checkNumber();
  }

  checkNumber(){
    if (this.value<0) {
      this.el.nativeElement.style.color = "#C9004C"
    }
  }

}
